import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// English translations
import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enPlatform from './locales/en/platform.json';
import enProducts from './locales/en/products.json';
import enSolutions from './locales/en/solutions.json';
import enCompany from './locales/en/company.json';
import enLegal from './locales/en/legal.json';
import enContact from './locales/en/contact.json';
import enRoles from './locales/en/roles.json';

const resources = {
  en: {
    common: enCommon,
    home: enHome,
    platform: enPlatform,
    products: enProducts,
    solutions: enSolutions,
    company: enCompany,
    legal: enLegal,
    contact: enContact,
    roles: enRoles,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'platform', 'products', 'solutions', 'company', 'legal', 'contact', 'roles'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
